import React, { useState, useEffect, useCallback } from 'react';
import { Form, Formik, Field } from 'formik';
import { useDispatch } from "react-redux";
import { useHistory } from 'react-router-dom';
import * as Yup from 'yup';
import AlertModal from 'web/components/AlertModal';
import TextInput from 'web/components/form-elements/TextInput';
import TextArea from 'web/components/form-elements/TextArea';
import Button from "web/components/Button";
import CheckboxInput from "web/components/form-elements/CheckboxInput";
import RadioButton from "web/components/form-elements/RadioButton";
import GroupPicture from 'web/components/GroupPicture'
import DP from 'web/assets/images/userPicDummy.jpeg'
import CloseIconBlackBg from 'web/assets/svg/CloseIconBlackBg'
import { Tooltip } from 'reactstrap';
import { createNetwork, } from 'redux/actions/myNetwork';
import information from "web/assets/images/informationIcon.png";
import { BoxContainer, BoxContainerHeader, CreateGroupWrappe, InputSection, GroupDiscoverability, ActionBtn } from "web/pages/private/CommonPages/MyNetworks/myNetworksStyled";

const CreateGroups = ({ pageLanguageContents, closeIconCallBack }) => {
  const dispatch = useDispatch();
  let history = useHistory();

  const token = localStorage.getItem('token');
  const [profileResponse, setProfileResponse] = useState(undefined);

  const [alertTypeState, setAlertTypeState] = useState();
  const [privacyState, setPrivacyState] = useState();
  const [groupImgState, setGroupImgState] = useState();
  const [modal, setModal] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [modalLink, setModalLink] = useState('');
  const toggleModal = () => setModal(!modal);

  const INITIAL_VALUES = {
    groupName: '',
    description: '',
    profileImage: '',
    appearsInSearchResult: '',
    allowMemberToConnection: false,
    requestReviewedByAdmin: false,
  };
  const VALIDATION_SCHEMA = Yup.object().shape({
    groupName: Yup.string().trim().required(pageLanguageContents?.Validations[0]?.GroupNameReq),
    description: Yup.string().trim().required(),
    appointment: Yup.string().trim().required(pageLanguageContents?.Validations[2]?.GroupDiscoverabilityReq),
  });
  const callCreateGroupApi = async (name, props) => {
    let data = {
      networkName: props.values.groupName,
      description: props.values.description,
      profileImage: groupImgState ? groupImgState : '',
      appearsInSearchResult: props.values.appointment ? props.values.appointment : '',
      allowMemberToConnection: props.values.permissionsRadio0 ? props.values.permissionsRadio0 : false,
      requestReviewedByAdmin: props.values.permissionsRadio1 ? props.values.permissionsRadio1 : false,
    }
    let formData = new FormData();
    const propsData = data;
    for (let prop in propsData) {
      formData.append(prop, propsData[prop])
    }
    const response = await dispatch(createNetwork(formData, token));

    if (response.status === "SUCCESS") {
      setAlertTypeState("createGroup")

      //for showing message from content sheet
      let indexVal = null
      if (pageLanguageContents?.Backend_Popups) {
        pageLanguageContents.Backend_Popups.forEach((val, index) => {
          if (Object.keys(val)[0] === response.message) {
            indexVal = index
          }
        })
      }
      if (indexVal !== null) setModalContent(pageLanguageContents.Backend_Popups[indexVal][response.message])
      else setModalContent(response.message);

      setModalLink('');
      toggleModal();
    } else {
      if (response.statusCode === 401) {
        history.push('/sign-in')
        window.location.reload(false);
      } else {
        setModalContent(response.message);
        setModalLink('');
        toggleModal();
      }
    }
  }
  let discoverabilityArr = [
    {
      value: "true",
      label: pageLanguageContents?.CreateGroup[9]?.Message_One,
      toolTip: pageLanguageContents?.CreateGroup[23]?.Message_One_Description,
    },
    {
      value: "false",
      label: pageLanguageContents?.CreateGroup[10]?.Message_Two,
      toolTip: 'Your Group will not appear in the Community Search results. Only the Admins will be able to Post or view Members.'
    },
  ]

  const permissionsRadioArr = [
    {
      value: "true",
      label: pageLanguageContents?.CreateGroup[11]?.AllowToInvite,
    },
    {
      value: "false",
      label: pageLanguageContents?.CreateGroup[12]?.Message_Three,
    },
  ];
  useEffect(() => {
    if (!localStorage.getItem('token')) {
      history.push('/sign-in')
      window.location.reload(false);
    }
  }, []);

  const [toolTip, setToolTip] = useState(false)
  const [discoverToolTip, setDiscovertoolTip] = useState(false)
  const infoDiscoverability = (infoTxt, infoType) => {
    return <>
      <img
        id={infoType}
        src={information}
        style={{
          paddingLeft: "5px",
          position: "relative",
          top: "-1px",
          width: '22px',
        }}
      />
      <Tooltip
        placement="right"
        isOpen={toolTip && discoverToolTip === infoType}
        target={infoType}
        toggle={() => {
          setToolTip(!toolTip)
          setDiscovertoolTip(infoType)
        }}
      >
        {infoTxt}
      </Tooltip>
    </>
  }

  return (
    <BoxContainer>
      <Formik
        initialValues={INITIAL_VALUES}
        validationSchema={VALIDATION_SCHEMA}
        onSubmit={(values) => {
        }}>
        {(props) => {
          const {
            isValid,
            dirty,
            values,
            errors,
            touched,
            setFieldValue,
          } = props;
          return (
            <>
              <Form>
                <BoxContainerHeader>
                  <h2>{pageLanguageContents?.CreateGroup[0]?.CreateGroup}</h2>{" "}
                  <CloseIconBlackBg
                    onClick={() => {
                      closeIconCallBack();
                    }}
                  />
                </BoxContainerHeader>
                <CreateGroupWrappe>
                  <div className="image-container">
                    <div className="image-wrapper">
                      <GroupPicture
                        name="groupImg"
                        callBackImg={(file) => {
                          setGroupImgState(file);
                        }}
                        gruopType={"new"}
                        Picture={DP}
                        ProfileName={""}
                        CompanyName=""
                        pageType="Network"
                        callBackClickEvent={() => {
                        }}
                        cancelPopupCallBack={() => {
                        }}
                      />
                    </div>
                    <h3>{pageLanguageContents?.CreateGroup[1]?.IndicatesRequired}</h3>
                  </div>
                </CreateGroupWrappe>
                <InputSection>
                  <p className="lable">
                    {pageLanguageContents?.CreateGroup[2]?.GroupName}<span className="star">*</span>
                  </p>
                  <TextInput
                    name="groupName"
                    placeholder={"Group Name"}
                    showErrorMessages={true}
                  />
                  <p className="lable">
                    {pageLanguageContents?.CreateGroup[3]?.Description}<span className="star">*</span>
                  </p>
                  <TextArea
                    name="description"
                    inputType="textAndNumber"
                    placeholder={pageLanguageContents?.CreateGroup[4]?.GroupPurpose}
                    rows="1"
                  />
                  {/* <TextInput
                    name="description"
                    placeholder={pageLanguageContents?.CreateGroup[4]?.GroupPurpose}
                    showErrorMessages={true}
                    maxLength={500}
                  /> */}
                </InputSection>
                <GroupDiscoverability>
                  <h2>
                    {pageLanguageContents?.CreateGroup[5]?.GroupDiscoverability}<span className="star">*</span>
                  </h2>
                  <div className="radio-field">
                    {discoverabilityArr &&
                      discoverabilityArr.map((value, index) => (
                        <div key={index}>
                          <Field
                            component={RadioButton}
                            name="appointment"
                            id={value.value}
                            defaultValue={discoverabilityArr[0].value}
                            onSelect={(e) => {
                              setPrivacyState(e.target.value)
                              if (e.target.value === "") {
                              } else {
                              }
                            }}
                            label={value.label}
                          />
                          {infoDiscoverability(value.toolTip, value.value)}
                        </div>
                      ))}
                  </div>

                  {privacyState === "true" && <>
                    <h2>{pageLanguageContents?.CreateGroup[6]?.Permissions}</h2>
                    <div className="checkbox-field-wrapper">
                      {permissionsRadioArr.map((value, i) => (
                        <div>
                          <CheckboxInput
                            name={"permissionsRadio" + i}
                            label={permissionsRadioArr[i].label}
                            handleSelect={(val, label) => {
                            }}
                          />
                        </div>
                      ))}
                    </div>
                  </>}

                </GroupDiscoverability>
                <ActionBtn>
                  <button
                    onClick={() => {
                      closeIconCallBack();
                    }}
                  >
                    {pageLanguageContents?.CreateGroup[7]?.Back}
                  </button>
                  <Button
                    type="app-green-button"
                    handleClick={() => {
                      callCreateGroupApi("groupName", props);
                    }}
                    disabled={!(isValid && dirty)}
                  >
                    {pageLanguageContents?.CreateGroup[8]?.Create}
                  </Button>
                </ActionBtn>
              </Form>
              <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title=""
                alertType={alertTypeState}
                content={modalContent}
                link={modalLink}
                callBackAlert={(val) => {
                  if (val === "createGroup") closeIconCallBack();
                }}
              />
            </>
          );
        }}
      </Formik>
    </BoxContainer>
  );
}



export default CreateGroups;
